import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material';

export function PageHeader() {
  const theme = useTheme();
  
  return (
    <Box style={{ 
      display: 'flex', 
      justifyContent: 'space-between', 
      alignItems: 'center', 
      marginBottom: 24 
    }}>
      <Box>
        <Typography variant='h4' color={theme.palette.text.primary}>Participantes</Typography>
        <Typography variant='caption' color={theme.palette.text.secondary}>
          Lista de participantes do evento
        </Typography>
      </Box>
    </Box>
  );
}